import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { IoMdClose } from "react-icons/io";
import "./blockedCommunity.css";
import { useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import { BiBorderRadius } from "react-icons/bi";
import ConfirmationDialog from "src/Components/ConfirmationDialog";
import API from "../../../../network/index";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "none",
  borderRadius: 5,
  px: 4, // padding left + right
  py: 2, // padding top + bottom
};

export default function UnblockRequestModal(props) {
  const {
    onOpenUnblockReqModal,
    onCloseUnblockModal,
    communityName,
    communityId,
  } = props;
  const userDetails = useSelector(
    (state) => state.SignInReducer?.userDetails || {}
  );

  const [unblockReqMsg, setUnblockReqMsg] = useState("");
  const [textmsg, setTextmsg] = useState("");
  const [confModalVisible, setConfModalVisible] = useState(null);

  useEffect(() => {
    const { displayName = "" } = userDetails?.userData || {};
    setTextmsg(
      `Dear Moderator,\n\nI request you to unblock my access to ${communityName} community.\n\nThank you,\n${displayName}`
    );
    setUnblockReqMsg(
      `Dear Moderator,%0A%0AI request you to unblock my access to ${communityName} community.%0A%0AThank you,%0A${displayName}`
    );
  }, [communityName, userDetails]);

  const onClose = () => {
    setConfModalVisible(null);
  };

  const onSendUnblockRequest = async () => {
    try {
      const formData = new FormData();
      formData.append("tenantId", communityId);
      formData.append("reqMsg", unblockReqMsg);
      const response = await API.sendUnblockRequest(formData);
      if (response?.data?.status === "Request sent successfully") {
        onCloseUnblockModal();
        setConfModalVisible({
          open: true,
          type: "success",
          title: response?.data?.status,
          acceptLabel: "Ok",
          onAccept: onClose,
        });
      }
    } catch (error) {
      console.error("Error in junblock request:", error);
      alert("Failed to send unblock request. Please try again.");
    }
  };

  return (
    <div>
      <Modal
        open={onOpenUnblockReqModal}
        onClose={onCloseUnblockModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="unblock-modal-header">
            <h1>Request to Unblock</h1>
            <button type="button" onClick={() => onCloseUnblockModal()}>
              <IoMdClose className="block-modal-close-icon" />
            </button>
          </div>
          <div>
            <textarea
              rows="7"
              cols="15"
              defaultValue={textmsg}
              className="unblock-request-textarea"
              readOnly
            />
          </div>
          <button
            type="submit"
            className="unblock-req-send-button"
            onClick={onSendUnblockRequest}
          >
            {/* {true ? <CircularProgress size={20} color="white" /> : "Send"} */}
            Send
          </button>
        </Box>
      </Modal>
      {confModalVisible?.open && <ConfirmationDialog {...confModalVisible} />}
    </div>
  );
}
